import { APIS } from '../../_config'
import { createAgentSaga } from './createAgentSaga'

const saga = createAgentSaga(APIS.REQUIREMENT_AGENT, 'Requirement Agent')

export const { createSession, chat, listSessions, getSessionMessages, deleteSession, submitFeedback } = saga
